import { Component, OnInit, Input } from '@angular/core';
import { Contatti } from 'my-lib-sanfelici/my-lib-sanfelici';

@Component({
  selector: 'app-contatto-view',
  templateUrl: './contatto-view.component.html',
  styleUrls: ['./contatto-view.component.scss']
})
export class ContattoViewComponent implements OnInit {
  @Input() contatto: Contatti;
  constructor() { }

  ngOnInit() {
  }

}
